import { useMemo } from "react";
import { object } from "yup";
import {
    stringValidationSchema,
    emailValidationSchema,
    dateValidationSchema,
} from "core/utils/form-validation-schema";

export function useAddStudentValidationSchema() {
    return useMemo(
        () => object().shape({
            first_name: stringValidationSchema(),
            last_name: stringValidationSchema(),
            email: emailValidationSchema(),
            day: stringValidationSchema(),
            month: stringValidationSchema(),
            year: stringValidationSchema(),
            gender: stringValidationSchema(),
            custom_gender: stringValidationSchema(),
            start_date: dateValidationSchema(),
        }),
        []
    );
}

export function useEditStudentValidationSchema() {
    return useMemo(
        () => object().shape({
            first_name: stringValidationSchema(),
            last_name: stringValidationSchema(),
            day: stringValidationSchema(),
            month: stringValidationSchema(),
            year: stringValidationSchema(),
            gender: stringValidationSchema(),
            custom_gender: stringValidationSchema(),
            start_date: dateValidationSchema(),
        }),
        []
    );
}
